import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "visually-hidden" }
const _hoisted_2 = ["id", "name", "value", "checked", "disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "facet-radio-mark",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_4 = ["for"]

import { SolrFacet, SolrFacetOption } from '../../modules/solr'; // eslint-disable-line import/no-relative-parent-imports


export default /*#__PURE__*/_defineComponent({
  __name: 'FacetOptionsSingle',
  props: {
    facet: {}
  },
  emits: ["change"],
  setup(__props: any, { emit }) {

const props = __props;





function key (option: SolrFacetOption): string {
    return `${option.label}|${option.value}|${option.selected ? 'y' : 'n'}}`;
}

function changeValue (event: Event): void {
    emit('change', props.facet.name, (event.target as HTMLInputElement).value, 'set');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", {
    class: _normalizeClass(`facet-type-${props.facet.field.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`)
  }, [
    _createElementVNode("legend", _hoisted_1, _toDisplayString(props.facet.label), 1 /* TEXT */),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.facet.options, (option) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key(option),
        class: _normalizeClass('facet-radio' + (option.count === 0 ? ' facet-radio-empty' : ''))
      }, [
        _createElementVNode("input", {
          id: 'facet-' + props.facet.name + '-' + option.value,
          type: "radio",
          class: "visually-hidden",
          name: props.facet.name,
          value: option.value,
          checked: option.selected,
          disabled: option.count === 0,
          onClick: changeValue
        }, null, 8 /* PROPS */, _hoisted_2),
        _hoisted_3,
        _createElementVNode("label", {
          for: 'facet-' + props.facet.name + '-' + option.value
        }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_4)
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}
}

})